import moment from 'moment';
import i18n from 'l10n';
import Handlebars from 'handlebars';

    var it = {};
    it.init = function (selector) {
        var handlerSmsEmailCounter = function(json) {
            var smsCount = json.SMS_COUNT;
            var emailCount = json.EMAIL_COUNT;
            var contactsCountSms = json.CONTACTS_COUNT_RECEIVED_SMS;
            var contactsCountEmail = json.CONTACTS_COUNT_RECEIVED_EMAIL;
            $(selector).find("#sms-sent-count_1").show().text(smsCount);
            var cl = Handlebars.helpers.dynamicFontSize(smsCount,
                $(selector).find("#sms-sent-count_1").data("font-length"));
            $(selector).find("#sms-sent-count_1").addClass(cl.toString());
            if (json.subscriptionLevel === 1) {
                var $emailsLeftDiv = $("#emailsLeftDiv");
                $emailsLeftDiv.prop("title", i18n.t("dashboard.remainingEmailTitle", { emails : json.emailsLeft }));
                $("#emailsLeftTitle").text(i18n.t("message.emailsLeft", { count : json.emailsLeft }));
                $("#emailsLeftText").text(json.emailsLeft);
                $("#daysToExpireText").text(json.daysToExpire >= 0 ? json.daysToExpire + 1 : 0); //Add one as in campaign-tile-simpleview
                $emailsLeftDiv.show();
                $("#daysLeftDiv").show();
            }
            $(selector).find("#email-sent-count_1").show().text(emailCount);
            cl = Handlebars.helpers.dynamicFontSize(emailCount,
                $(selector).find("#email-sent-count_1").data("font-length"));
            $(selector).find("#email-sent-count_1").addClass(cl.toString());
            $(selector).find("#email-sent-count-text").text(i18n.t("dashboard.emails", {count : emailCount}));
            $(selector).find("#contacts_count_sms_1").show().text(contactsCountSms);
            cl = Handlebars.helpers.dynamicFontSize(contactsCountSms,
                $(selector).find("#contacts_count_sms_1").data("font-length"));
            $(selector).find("#contacts_count_sms_1").addClass(cl.toString());
            $(selector).find("#contacts_count_sms-text").text(i18n.t("dashboard.contacts", {count : contactsCountSms}));
            $(selector).find("#contacts_count_email_1").show().text(contactsCountEmail);
            cl = Handlebars.helpers.dynamicFontSize(contactsCountEmail,
                $(selector).find("#contacts_count_email_1").data("font-length"));
            $(selector).find("#contacts_count_email_1").addClass(cl.toString());
            $(selector).find("#contacts_count_email-text").text(i18n.t("dashboard.contacts", {count : contactsCountEmail}));
        };
        $.getDefaultJSONQ('/CampaignCloud/Report/SmsEmailCount', null, handlerSmsEmailCounter);
    };
    export default it;
